import React from 'react';
import SSOAuth from './shared/SSOAuth';
import AccountsDashboard from './components/AccountsDashboard';
import './App.css';

function App() {
  return (
    <SSOAuth>
      <div className="App">
        <AccountsDashboard />
      </div>
    </SSOAuth>
  );
}

export default App;
